/** createdFromMonthやcreatedToMonthのDateTime型を文字列化するときのフォーマットを表す */
var datetimeMonthStringFormat = 'yyyy-MM-dd';
/** 絞り込み状態を表すクラス */
var FilterCondition = /** @class */ (function () {
    /** FilterConditionのコンストラクタ */
    function FilterCondition(props) {
        var _a, _b;
        this.props = props;
        this.name = (_a = props.name) !== null && _a !== void 0 ? _a : defaultFilterConditionObject.name;
        var _c = sortDateTimeToAsc({
            fromDateTime: props.createdFromMonth || null,
            toDateTime: props.createdToMonth || null,
        }), createdFromMonth = _c.fromDateTime, createdToMonth = _c.toDateTime;
        this.createdFromMonth = createdFromMonth !== null && createdFromMonth !== void 0 ? createdFromMonth : defaultFilterConditionObject.createdFromMonth;
        this.createdToMonth = createdToMonth !== null && createdToMonth !== void 0 ? createdToMonth : defaultFilterConditionObject.createdToMonth;
        this.drillType = (_b = props.drillType) !== null && _b !== void 0 ? _b : defaultFilterConditionObject.drillType;
    }
    FilterCondition.fromQuery = function (props) {
        return new FilterCondition({
            name: props.name,
            createdFromMonth: props.createdFromMonth,
            createdToMonth: props.createdToMonth,
            drillType: props.drillType,
        });
    };
    Object.defineProperty(FilterCondition.prototype, "isEmpty", {
        get: function () {
            if (this.name.length > 0)
                return false;
            if (this.createdFromMonth !== null)
                return false;
            if (this.createdToMonth !== null)
                return false;
            if (this.drillType !== null)
                return false;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterCondition.prototype, "toRestApiFilterCondition", {
        /**
         * RestAPIでリクエストを送る際のオブジェクトを返す
         */
        get: function () {
            var _a, _b;
            return {
                name: this.name,
                afterCreatedDatetime: ((_a = this.createdFromMonth) === null || _a === void 0 ? void 0 : _a.toFormat(datetimeMonthStringFormat)) || undefined,
                untilCreatedDatetime: ((_b = this.createdToMonth) === null || _b === void 0 ? void 0 : _b.endOf('month').toFormat(datetimeMonthStringFormat)) || undefined,
                drillType: this.drillType || undefined,
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterCondition.prototype, "fromDatetimeConvertString", {
        get: function () {
            if (!this.createdFromMonth)
                return '';
            return this.createdFromMonth.year + "-" + this.createdFromMonth.month.toString().padStart(2, '0');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FilterCondition.prototype, "toDatetimeConvertString", {
        get: function () {
            if (!this.createdToMonth)
                return '';
            return this.createdToMonth.year + "-" + this.createdToMonth.month.toString().padStart(2, '0');
        },
        enumerable: false,
        configurable: true
    });
    return FilterCondition;
}());
export { FilterCondition };
/**
 * 開始時と終了時のタイムスタンプを取得、順番をチェックし、両方指定されている場合は開始時が先に来るように直して返す
 * 片方しか指定されていない場合は、そのまま返す
 */
export var sortDateTimeToAsc = function (_a) {
    var fromDateTime = _a.fromDateTime, toDateTime = _a.toDateTime;
    var shouldSwapDateTime = fromDateTime != null && toDateTime != null && fromDateTime > toDateTime;
    return {
        fromDateTime: shouldSwapDateTime ? toDateTime : fromDateTime,
        toDateTime: shouldSwapDateTime ? fromDateTime : toDateTime,
    };
};
export var defaultFilterConditionObject = {
    name: '',
    createdFromMonth: null,
    createdToMonth: null,
    drillType: null,
};
